import React, { useEffect, useState } from "react";
import Modal from "../Modal/Modal";
import { registerNetworkErrorListener, unregisterNetworkErrorListener } from "../../utils/networkErrorBus";
import "./NetworkErrorModal.css";

// Global popup shown whenever an API call fails to get a response or hits a server error.
const NetworkErrorModal: React.FC = () => {
  const [message, setMessage] = useState<string | null>(null);
  const [resolver, setResolver] = useState<((shouldRetry: boolean) => void) | null>(null);

  useEffect(() => {
    const listener = (msg: string, resolve: (shouldRetry: boolean) => void) => {
      setMessage(msg);
      setResolver(() => resolve);
    };
    registerNetworkErrorListener(listener);
    return () => unregisterNetworkErrorListener(listener);
  }, []);

  const close = (shouldRetry: boolean) => {
    resolver?.(shouldRetry);
    setMessage(null);
    setResolver(null);
  };

  return (
    <Modal isOpen={message !== null} onClose={() => close(false)}>
      <div className="network-error-card">
        <div className="network-error-icon">!</div>
        <h3 className="network-error-title">Something went wrong</h3>
        <p className="network-error-message">{message}</p>
        <p className="network-error-question">Do you want to retry?</p>
        <div className="network-error-actions">
          <button className="network-error-btn secondary" onClick={() => close(false)}>Cancel</button>
          <button className="network-error-btn primary" onClick={() => close(true)}>Retry</button>
        </div>
      </div>
    </Modal>
  );
};

export default NetworkErrorModal;
